interface PromptConfirmationSelectTheme {
  textFontSize: number | string;
  dispatchPanelHeaderColor: string;
  iconColor: string;
  palette: {
    error: {
      main: string;
    };
  };
}

const styles = (theme: PromptConfirmationSelectTheme) => ({
  wrapper: {
    flex: '0 1 auto'
  },
  container: {
    display: 'flex' as const,
    alignItems: 'flex-start' as const,
    flexWrap: 'nowrap' as const
  },
  rowLabel: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
    marginRight: 6,
    flexShrink: 0,
    whiteSpace: 'nowrap' as const,
    marginTop: 8
  },
  selectColumn: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    flexShrink: 0
  },
  InputLabelProps: {
    color: theme.iconColor,
    transform: 'translate(14px, 13px) scale(1)'
  },
  selectFilterClass: {
    display: 'flex' as const,
    minWidth: 92,
    flexShrink: 0,
    '&>div': {
      flex: 1,
      width: '100%'
    }
  },
  selectInput: {
    minWidth: 104,
    margin: 0
  },
  suffix: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
    whiteSpace: 'nowrap' as const,
    flexShrink: 0,
    marginTop: 8,
    marginLeft: 4
  },
  errorText: {
    fontSize: theme.textFontSize,
    color: theme.palette.error.main
  }
});

export default styles;
